export default __webpack_public_path__ + "static/media/ic_tibet.e89e22ae.svg";